// @ts-strict-ignore
import { Component, Input } from '@angular/core';

@Component({
  selector: 'lm-saved-search-manage',
  standalone: false,
  template: `
    @if ((listSpec)) {
      <lm-list #lmlist
        [listUrlInfo]="listUrlInfo"
        [listSpec]="listSpec"
        [ngStyle]="{'width': '100%'}"
        >
      </lm-list>
    }
    `
})
export class LMSavedSearchManageComponent {

  @Input() listSpec: LMListSpec;
  @Input() listUrlInfo: LMListUrlInfo;
}
